<label
  class="custom-checkbox"
  [ngClass]="{
    'disabled': disabled && !isUnavailable,
    'ingredient': ingredient,
    'position-relative': ingredient,
    'align-center': alignCenter,
    'outline': focused,
    'has-content': !noContent
  }"
>
  <input
    #inputRef
    type="checkbox"
    class="sr-only"
    [checked]="checked"
    [disabled]="disabled && !isUnavailable"
    [attr.name]="name"
    [attr.aria-label]="ariaLabel || null"
    (change)="onChange($event)"
    (keydown.enter)="onChange($event); $event.preventDefault();"
    (focus)="onInputFocus()"
    (blur)="onInputBlur()"
  />

  <span
    class="custom-checkbox-indicator"
    aria-hidden="true"
    [ngClass]="{
      'selection-bg-color selection-inverse-text-color': checked,
      'custom-checkbox-indicator-check': checked && isHalfAndHalf,
      'border-radius': isUnavailable && storeConfig?.showSizeSpecificIngredients
    }"
  ></span>

  <span class="custom-checkbox-details" *ngIf="!noContent">
    <ng-content></ng-content>
  </span>

  <span *ngIf="noContent" class="sr-only" aria-hidden="true">
    {{ ariaLabel }}
  </span>

  <span *ngIf="isUnavailable" class="sr-only">
    {{ 'component.item_editor.choice.ingredient.ingredient_card.not_available' | translate }}
  </span>

  <fa-icon
    *ngIf="isUnavailable && storeConfig?.showSizeSpecificIngredients"
    class="disabled-icon text-danger"
    [icon]="faBan"
    aria-hidden="true"
  ></fa-icon>
</label>
